// Firebase Authentication: a reactive `user` store plus sign-in/out helpers.
// Login is optional — the app works signed-out (localStorage only); signing in
// turns on cloud sync (see sync.ts).

import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as fbSignOut,
  onAuthStateChanged,
  type User,
} from 'firebase/auth';
import { writable } from 'svelte/store';
import { auth } from './firebase';

/** The current signed-in user, or null. Null until `authReady` is true. */
export const user = writable<User | null>(null);
/** False until Firebase has resolved the initial auth state. */
export const authReady = writable(false);

onAuthStateChanged(auth, (u) => {
  user.set(u);
  authReady.set(true);
});

export function signInWithGoogle(): Promise<unknown> {
  return signInWithPopup(auth, new GoogleAuthProvider());
}

export function signInWithEmail(email: string, password: string): Promise<unknown> {
  return signInWithEmailAndPassword(auth, email, password);
}

export function registerWithEmail(email: string, password: string): Promise<unknown> {
  return createUserWithEmailAndPassword(auth, email, password);
}

export function signOutUser(): Promise<void> {
  return fbSignOut(auth);
}
